<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="基本信息" key="1">
          <a-row class="form-row">
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色">
                <a-input :read-only="params.isShow || params.isStatic" placeholder="请输入角色" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入角色' }]}]"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="显示名称">
                <a-input :read-only="this.params.isShow" placeholder="请输入显示名称" v-decorator="[
          'displayName',
          {rules: [{ required: true, message: '请输入显示名称' }],initialValue:data.displayName}]"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述">
                <a-input :read-only="this.params.isShow" placeholder="请输入描述" v-decorator="[
          'description',
          {rules: [],initialValue:data.description}]"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="form-row"></a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane tab="权限" key="2" forceRender>
          <a-tree checkable checkStrictly :treeData="allPermissions" :checkedKeys="grantedPermissions" @check="this.onPermissionCheck" :disabled="this.params.isShow"></a-tree>
        </a-tab-pane>
      </a-tabs>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";

let allPermissions = [];
let grantedPermissions = [];
const defaultData = {
  id: 0,
  name: "",
  description: "",
  displayName: "",
  permissions: []
};
export default {
  name: "hp-manager-page-role-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      allPermissions: [],
      grantedPermissions: [],
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getdetailRole();
    } else {
      this.data = exzends(defaultData);
      this.getAllPermissions(null);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    onPermissionCheck(checkedKeys, info) {
      this.grantedPermissions = checkedKeys.checked;
      console.log(this.grantedPermissions);
    },
    async getdetailRole() {
      this.loading = true;
      let result = await api.GetRoleForEdit({ roleId: this.params.id });
      if (result) {
        this.data = result.role;
        this.data.name = this.data.name;
        this.data.displayName = this.data.displayName;
        this.data.description = this.data.description;
        this.getAllPermissions(result.permissions);
        this.grantedPermissions = result.grantedPermissions;
        // this.checkPermission = this.grantedPermissions;
        console.log(this.grantedPermissions);
      }
      this.loading = false;
    },
    setChildrenNode(permissionNode) {
      let childNode = [];
      if (permissionNode && permissionNode.length > 0) {
        permissionNode.forEach(a => {
          childNode.push({
            title: a.displayName,
            key: a.name,
            children: this.setChildrenNode(a.children)
          });
        });
      }
      return childNode;
    },
    async getAllPermissions(permissions) {
      this.loading = true;
      if (permissions != null) {
        permissions.forEach(element => {
          this.allPermissions.push({
            title: element.displayName,
            key: element.name,
            children: this.setChildrenNode(element.children)
          });
        });
      } else {
        let result = await api.GetAllPermissions({});
        if (result) {
          result.items.forEach(element => {
            this.allPermissions.push({
              title: element.displayName,
              key: element.name,
              children: this.setChildrenNode(element.children)
            });
          });
        }
      }

      this.loading = false;
    },

    async submitHandler() {
      await api.AddOrUpdateRole(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        description: value.description,
        displayName: value.displayName,
        permissions: this.grantedPermissions
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.UpdateRole(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddRole(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Admins/Role/Add.vue